import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import { createTemplateAccountExperiencesQueryKey } from '@/utils/queryKeys';
import type {
  DisableExperienceTemplateMutation,
  DisableExperienceTemplateMutationVariables,
} from './useDisableExperienceTemplate.generated';

const mutation = gql`
  mutation DisableExperienceTemplate($input: DisableExperienceTemplateInput!) {
    disableExperienceTemplate(input: $input)
  }
`;

export const useDisableExperienceTemplate = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, variables } = useMutation<
    DisableExperienceTemplateMutation,
    QueryError,
    DisableExperienceTemplateMutationVariables
  >({
    mutationFn: (variables) => gqlClient.request(mutation, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: createTemplateAccountExperiencesQueryKey(),
      });
    },
  });

  const isDisabling = (experienceId: string) =>
    isPending && variables?.input.experienceId === experienceId;

  return { disableExperienceTemplate: mutate, isDisabling };
};
